import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const Component = lazy(() =>
  import("@scenes/SubscriptionPages/components/SubscriptionPagesSection/ReactSectionEditSubscriptionGroupNRO").then(
    (module) => ({
      default: module.ReactSectionEditSubscriptionGroupNRO,
    })
  )
);

export const usersSubscriptionGroupsSubscriptionGroupIdNRO: NavigationRoutingObject = {
  section: "audience",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("users-subscription-groups-subscription-group-id-nro-heading", "Subscription Group Details"),
  pageNameForTracking: () => "Subscription Group Details",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("users-subscription-groups-subscription-group-id-nro-description", "Subscription Group Details"),
  getDeveloperNavigationAllowed: () => {
    return true;
  },
  // NOTE: if you want to add an 'additionalSearchTerm', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchTerm' and follow the prompts
  additionalSearchTerms: () => [],
  // NOTE: when adding additionalSearchableFeatures make sure one of the
  // query params of the feature matches the key name of the feature.
  // NOTE 2: if you want to add an 'additionalSearchableFeature', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchableFeature' and follow the prompts
  additionalSearchableFeatures: () => ({}),
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  Component: Component,
  defaultRoute: "/users/subscription_groups/subscription_groups/:appGroupId",
};
